import { useEffect } from 'react'

import BATCHED_EVENT_LIMIT from '@src/constants/batchedEventLimit'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'
import { batchedAnalytics } from '@src/quince-site-common/src/utils/batched-analytics'
import { getProductDataForBatchedAnalytics } from '@src/quince-site-common/src/utils/getProductDataForBatchedAnalytics'
import { runWhenMainThreadIdle } from '@src/quince-site-common/src/utils/interaction-scheduling'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { getProductTagsDataForBatchedAnalytics } from '../utils/getProductTagsDataForBatchedAnalytics'

export const useBatchedAnalyticsForProductCard = ({
  productViewTracker,
  trackingMetaData,
}: {
  productViewTracker?: string
  trackingMetaData?: TrackingMetaData
}) => {
  useEffect(() => {
    if (productViewTracker) {
      batchedAnalytics.initializeBatchedAnalyticsEvent({
        tracker: productViewTracker,
        eventLimit: BATCHED_EVENT_LIMIT[TELEMETRY_EVENT_NAMES.BULK_PRODUCT_CARD_VIEW],
        debouncePeriod: 1000,
      })
      batchedAnalytics.trackBatchedAnalytics({
        id: `internalAnalytics-${productViewTracker}`,
        tracker: productViewTracker,
        callback: ({ events }) => {
          runWhenMainThreadIdle(() => {
            const productList = events.map(event => getProductDataForBatchedAnalytics(event))
            const tagsCount = getProductTagsDataForBatchedAnalytics(productList)
            trackEvent(TELEMETRY_EVENT_NAMES.BULK_PRODUCT_CARD_VIEW, {
              productList: productList,
              tagsCount: tagsCount,
              ...trackingMetaData?.context,
            })
          })
        },
      })
    }
  }, [productViewTracker, trackingMetaData])
}
